<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      class="stroke"
      x="1.25"
      y="2.25"
      width="14"
      height="14"
      rx="2"
      fill="none"
      stroke-width="1.5"
    />
    <path
      class="knockout"
      d="M10 5L12.5 7.5L16 2"
      fill="none"
      stroke-width="5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      class="stroke"
      d="M10 5L12.5 7.5L16 2"
      fill="none"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "ReadIcon",
});
</script>

<style scoped lang="scss">
@use "./icon.scss";
</style>
